// api/bchHome.js
import { apiGet } from './http'

/**
 * BCH 首页总览。
 * 网关完整地址通常是 /admin/app/bch/home/overview。
 */
export function getBchHomeOverview(config = {}) {
  return apiGet(
    '/app/bch/home/overview',
    {},
    config
  )
}
